import { Component } from '@angular/core';

@Component({
  selector: 'app-education-svg',
  templateUrl: 'education-svg.component.html'
})
export class EducationSvgComponent {

}
